
/**
* Events
*	Triggers
*		na-microphoneStarted.vidbaby
*		na-microphoneData.vidbaby
*		na-microphoneReady.vidbaby
*		na-microphoneStopped.vidbaby
*	Listening
*		na-microphoneToggle.vidbaby
*		na-microphoneStart.vidbaby
*		na-microphoneStop.vidbaby
*/

import audio from './pcmAudio.js';

var socket, ws;
var ready = false;
var running = false;

audio.ondataavailable = data => {
	ws.emit('message', data);
}

async function start() {
	if(running) return;
	running = true;
	vidbaby.$(document).trigger('na-microphoneStarted.vidbaby');

	if(!ws) {
		ws = socket.connect();
		ws.on('disconnect', () => stop());
		ws.on('connect_error', () => stop());
		ws.on('message', function(data) {
			vidbaby.$(document).trigger('na-microphoneData.vidbaby', data);
			if (data.isFinal) {
				stop();
			}
		});
	} else if(ws.disconnected) {
		socket.connect();
	}

	await audio.start();

	vidbaby.$(document).trigger('na-microphoneReady.vidbaby');
}

function stop() {
	if(!running) return;
	running = false;
	audio.stop();
	
	setTimeout(() => {
		if(ws && !ws.disconnected) ws.disconnect();
		vidbaby.$(document).trigger('na-microphoneStopped.vidbaby');
	}, 300);
}

export default {
	ready,
	running,
	init() {
		if(ready) return;
		vidbaby.util.readScript(vidbaby.libraryPath + '/assets/js/socket.io.js');
		socket = io(vidbaby.config.env.socketServer, { autoConnect: false });
		vidbaby.$( document ).on('na-microphoneToggle.vidbaby', function(event) {
			if(running) stop();
			else start();
		});
		vidbaby.$( document ).on('na-microphoneStart.vidbaby', function(event) {
			start();
		});
		vidbaby.$( document ).on('na-microphoneStop.vidbaby', function(event) {
			stop();
		});
		ready = true;
	}
};